import { FC } from "react";
import { ChequeSearchFormProps } from "./types";
import { useThemeStore } from "../../../stores";
import { Row } from "../../containers";
import { DateInput, NumberInput, SelectorInput, TextInput } from "../../inputs";
import { Bank, ChequeStatusType } from "../../../types";
import { BANKS, CHEQUE_STATUS_LIST } from "../../../constants";
import { AlignItems, JustifyContent } from "../../containers/types";
import { Button } from "../../buttons";

const ChequeSearchForm: FC<ChequeSearchFormProps> = ({
  account_no,
  bank,
  fromDate,
  name,
  number,
  price,
  shenase,
  toDate,
  confirmedWith,
  status,
  setAccountNo,
  setBank,
  setFromDate,
  setName,
  setNumber,
  setPrice,
  setShenase,
  setToDate,
  setConfirmedWith,
  setStatus,
  buttons = [],
  onSearch = () => {},
  readOnly = false,
}) => {
  const theme = useThemeStore((s) => s.theme);

  return (
    <>
      <Row
        gap={20}
        className="finance-input-row"
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        <TextInput
          label="نام طرف حساب"
          value={name}
          setValue={setName}
          inputProps={{ readOnly }}
        />
        <TextInput
          label="شماره چک"
          value={number}
          setValue={setNumber}
          inputProps={{ readOnly }}
        />
        <TextInput
          label="شناسه"
          value={shenase}
          setValue={setShenase}
          inputProps={{ readOnly }}
        />
      </Row>
      <Row
        gap={20}
        className="finance-input-row"
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        <DateInput
          date={fromDate}
          setDate={setFromDate || (() => {})}
          label="از تاریخ"
          readOnly={readOnly}
        />
        <DateInput
          date={toDate}
          setDate={setToDate || (() => {})}
          label="تا تاریخ"
          readOnly={readOnly}
        />
        <SelectorInput<Bank>
          items={BANKS}
          label="بانک"
          selected={bank}
          setSelected={setBank || (() => {})}
          compareFn={(b, v) => b.fa.toLowerCase().includes(v.toLowerCase())}
          stringField={"fa"}
          uniqueKey={"name"}
          renderStrings={["fa"]}
          readOnly={readOnly}
        />
      </Row>
      <Row
        gap={20}
        className="finance-input-row"
        style={{ width: "100%", marginBottom: "1rem" }}
        alignItems={AlignItems.End}
      >
        <TextInput
          label="شماره حساب"
          value={account_no}
          setValue={setAccountNo}
          inputProps={{ readOnly }}
        />
        <NumberInput
          label="مبلغ (ریال)"
          value={price}
          setValue={setPrice || (() => {})}
          price
          inputProps={{ readOnly }}
        />
        <SelectorInput<ChequeStatusType>
          items={CHEQUE_STATUS_LIST}
          label="وضعیت چک"
          selected={status}
          setSelected={setStatus || (() => {})}
          compareFn={(s, v) => s.fa.toLowerCase().includes(v.toLowerCase())}
          stringField={"fa"}
          uniqueKey={"status"}
          renderStrings={["fa"]}
          readOnly={readOnly}
        />
      </Row>
      <Row
        gap={20}
        className="finance-input-row-2"
        style={{ width: "100%" }}
        alignItems={AlignItems.End}
      >
        <TextInput
          label="تایید شده به نام"
          value={confirmedWith}
          setValue={setConfirmedWith}
          inputProps={{ readOnly }}
        />
        {!readOnly ? (
          <Row
            style={{ width: "100%", height: 41 }}
            gap={20}
            className="finance-input-row-3"
            justifyContent={JustifyContent.End}
          >
            {buttons.includes("search") ? (
              <Button
                onClick={onSearch}
                background={theme.primary}
                color={theme.textOnprimary}
              >
                جستجو
              </Button>
            ) : (
              <></>
            )}
          </Row>
        ) : (
          <></>
        )}
      </Row>
    </>
  );
};

export default ChequeSearchForm;
